export default {
  'sidebar.title.enterprises': 'Enterprises',
  'sidebar.title.transactions': 'Transactions',
  'sidebar.title.cards': 'Cards',
  'sidebar.title.offers': 'Offers',
  'sidebar.title.notifications': 'Notifications',
  'sidebar.title.service': 'Service+'
}